/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-11 18:40:42
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-03-06 16:54:33
 */
import axios from 'axios' ;
import { stringToByte, byteToString } from './stringBytes' ;
import uuidv1 from 'uuid/v1' ;
import CryptoJS from 'crypto-js' ;
import base64 from 'base64-url' ;
import Cookie from './cookie' ;
import { getUid } from './helper' ;

/**
 * 生成HTTP请求函数
 * @param {String} url 后端服务地址
 * @param {Object} params 参数
 * @param {String} projectName 项目名称 用于错误上报
 */
const http5 = async ({ url, params = {}, projectName }) => {
    let uid = "";
    if (getUid().length > 0) { uid = getUid(); }
    const zpVersion = Cookie.get("zp-version") || '0.0.0';
    let config = {
        contentType: 'form',
        headers: {
            "zp-version": zpVersion,
            "Content-Type": "application/x-www-form-urlencoded"
        }
    };
    config.withCredentials = true;
    const uuid = uuidv1().replace(/\-/g, "");
    const keyArr = stringToByte("2" + uuid);
    // console.log("uuid",uuid,keyArr) ;
    // aes加密的password
    let password = keyArr.map((item, index) => {
        if (index % 3 == 2) {
            return item ^ 2
        }
        return item;
    });
    password = byteToString(password);
    password = base64.encode(password);
    password = password.slice(0, 16);
    // 需要加密的字段
    const { cmd, ...others } = params;
    // console.log('---', cmd, others) ;
    let hbody = Object.keys(others).length == 0 ? JSON.stringify({ uuid }) : JSON.stringify(others);
    hbody = CryptoJS.AES.encrypt(hbody, CryptoJS.enc.Utf8.parse(password), { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString();
    const sign = CryptoJS.MD5(`${params.cmd}&hbody=${hbody}&uuid=${uuid}&index=h5&h5`).toString();
    // 代码 “不” 多余
    // 两次encode
    hbody = encodeURIComponent(hbody);
    hbody = encodeURIComponent(hbody);
    const requestBody = {
        hbody,
        uuid,
        sign,
        cmd,
        key: "h5",
        index: "h5"
    }
    requestBody.uid = uid;
    let formData = "";
    for (let key in requestBody) {
        formData += `${key}=${requestBody[key]}&`;
    }
    config = { ...config, data: formData, method: 'post', url };
    let errorResult = undefined;
    try {
        // console.log('config',config) ;
        const res = await axios(config);
        // console.log('h5-res',res);
        errorResult = { ...res }
        //  解密过程
        let { result, resultcode,...others } = res.data;
        if (parseInt(resultcode) === 10000) {
            if (typeof result == "string") {

                result = CryptoJS.AES.decrypt(result, CryptoJS.enc.Utf8.parse(password), { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8);
                res.data.result = JSON.parse(result);
                // console.log('44444',result);
            }
        } else {
            console.group("返回值异常:");
            // console.log(res.data);
            console.log("uuid:" + uuid);
            console.log("反解请去：http://zoro.58corp.com/zoro/client/index");
        }
        //返回result 少一层解析
        return {
            result:res.data.result,
            resultcode,
            ...others
        };
    }
    catch (error) {
        console.error(error,"http_zcm");
    }
}

export default http5;
